import React, { FC } from 'react';
import {
  ButtonPrimaryTextOnly,
  Box,
  InputBoxed,
  Dropdown,
  Typography,
} from '@creditas-ui/react';
import { SelectTerm } from '@creditasmx-utilities/components';
import {
  TERMS,
  INPUT_NAMES,
  BUTTON_TEST_ID,
  PURCHASE_INTENT_OPTIONS,
} from './Form.constants';
import { FormFooter } from '../';
import { useForm } from './Form.hook';
import { FormProps, OptionProps } from './Form.types';
import {useAutoCard} from "../Card/Card.hook";
import {currency} from "../../../shared/hooks/useMask"

export const Form: FC<FormProps> = ({ externalAutoId }) => {
  const {
    errors,
    isLoading,
    downPayment,
    onBlurDownPayment,
    onChangeDownPayment,
    phone,
    onChangePhone,
    onBlurPhone,
    handleContinue,
    handleChangeDrop,
  } = useForm(externalAutoId);
  
  const { autoInfo } = useAutoCard();
  const stringAutoPrice = autoInfo?.price.slice(1)?.replace(',', '');

  const percentagePriceValue = parseFloat(stringAutoPrice?? '') * 0.2;
  
  const percentageToShow = currency.getMaskedValue(String(percentagePriceValue))
  const defaultLabelMessage = 'El enganche mínimo para este auto es de: '
  
  const errorMessage = errors[INPUT_NAMES.DOWN_PAYMENT] === defaultLabelMessage
  
  return (
    <Box paddingTop="32px">
      <InputBoxed
        label="¿Cuánto tienes para el enganche?"
        data-testid={INPUT_NAMES.DOWN_PAYMENT}
        name={INPUT_NAMES.DOWN_PAYMENT}
        onChange={onChangeDownPayment}
        onBlur={onBlurDownPayment}
        value={downPayment}
        pattern="\d*"
        inputMode="numeric"
        error={ errorMessage ? `${errors[INPUT_NAMES.DOWN_PAYMENT]} ${percentageToShow}` : errors[INPUT_NAMES.DOWN_PAYMENT]}
        id={INPUT_NAMES.DOWN_PAYMENT}
        data-order={1}
      />
      {
        !errors[INPUT_NAMES.DOWN_PAYMENT] &&
          <div style={{paddingTop: '8px'}}>
            <Typography
            variant="bodyXsRegular"
            color="neutral.60"
            component="span"
            >
              {defaultLabelMessage}
              <Typography
              variant="bodyXsRegular"
              color="primary.80"
              component="span"
              >
                {percentageToShow}
              </Typography>
            </Typography>
          </div>
      }
      <Box marginTop="24px" marginBottom="24px">
        <SelectTerm
          text="Selecciona el plazo para tu crédito"
          options={TERMS}
          onChangeOption={(selectedOption: OptionProps): void => {
            const { value } = selectedOption;
            handleChangeDrop(INPUT_NAMES.TERM, value);
          }}
          error={errors[INPUT_NAMES.TERM]}
          data-testid="TERM_EXP"
          data-order={2}
        />
      </Box>
      <Box marginTop="24px" marginBottom="24px">
        <Dropdown
          text="¿Cuándo necesitas el préstamo?"
          options={PURCHASE_INTENT_OPTIONS}
          onChangeOption={(selectedOption: OptionProps): void => {
            const { value } = selectedOption;
            handleChangeDrop(INPUT_NAMES.PURCHASE_INTENT, value);
          }}
          error={errors[INPUT_NAMES.PURCHASE_INTENT]}
          data-testid={INPUT_NAMES.PURCHASE_INTENT}
          id={INPUT_NAMES.PURCHASE_INTENT}
          data-order={3}
        />
      </Box>
      
      <InputBoxed
        label="Número celular"
        id={INPUT_NAMES.PHONE}
        data-testid={INPUT_NAMES.PHONE}
        name={INPUT_NAMES.PHONE}
        onChange={onChangePhone}
        onBlur={onBlurPhone}
        value={phone}
        pattern="\d*"
        inputMode="numeric"
        error={errors[INPUT_NAMES.PHONE]}
        helperText="Aquí te enviaremos la información del préstamo."
        data-order={4}
      />

      <FormFooter />
      <ButtonPrimaryTextOnly
        size="large"
        width="fixed"
        onClick={handleContinue}
        loading={isLoading}
        data-testid={BUTTON_TEST_ID}
      >
        Continuar
      </ButtonPrimaryTextOnly>
    </Box>
  );
};
